import { render, staticRenderFns } from "./widgets.vue?vue&type=template&id=3286ad8a&scoped=true&"
import script from "./widgets.ts?vue&type=script&lang=ts&"
export * from "./widgets.ts?vue&type=script&lang=ts&"
import style0 from "./widgets.scss?vue&type=style&index=0&id=3286ad8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286ad8a",
  null
  
)

export default component.exports